export default __webpack_public_path__ + "static/Wallop-Thin-8fa7662eead4a037231f570d87deb70c.woff2";